/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Updatefailed1Inputs */

const zh_profile_updatefailed1 = /** @type {(inputs: Profile_Updatefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新失败`)
};

const en_profile_updatefailed1 = /** @type {(inputs: Profile_Updatefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update failed`)
};

const es_profile_updatefailed1 = /** @type {(inputs: Profile_Updatefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar`)
};

/**
* | output |
* | --- |
* | "Update failed" |
*
* @param {Profile_Updatefailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const profile_updatefailed1 = /** @type {((inputs?: Profile_Updatefailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Updatefailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_profile_updatefailed1(inputs)
	if (locale === "en") return en_profile_updatefailed1(inputs)
	return es_profile_updatefailed1(inputs)
});
export { profile_updatefailed1 as "profile_updateFailed" }